import styled from "./styled";

module.exports = styled;
export default styled;
export * from "./styled";
